var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full relative"},[(_vm.iframeUrl == '')?_c('div',{staticClass:"w-full h-full relative"},[_c('p',{staticClass:"align-center"},[_vm._v(_vm._s(_vm.tipName))])]):_c('iframe',{staticClass:"w-full h-full",attrs:{"src":_vm.iframeUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }